import { Link } from "react-router-dom";
import { formatDate } from "@/lib/helpers";
import { CATEGORY_COLORS } from "@/lib/helpers";
import { ArrowRight, Calendar } from "lucide-react";

export function SectionHeading({ eyebrow, title, description, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
      <div>
        {eyebrow && <div className="eyebrow mb-2">{eyebrow}</div>}
        <h2 className="text-2xl sm:text-3xl font-extrabold text-navy">{title}</h2>
        {description && <p className="text-slate-500 mt-2 max-w-2xl">{description}</p>}
      </div>
      {action}
    </div>
  );
}

export function NewsCard({ item, testid }) {
  return (
    <Link
      to={`/info/${item.slug}`}
      data-testid={testid}
      className="group bg-white rounded-xl border border-slate-200 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col"
    >
      <div className="relative h-48 overflow-hidden bg-slate-100">
        <img src={item.thumbnail} alt={item.title} loading="lazy" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
        <span className={`absolute top-3 left-3 text-[11px] font-bold px-2.5 py-1 rounded-full ${CATEGORY_COLORS[item.category] || "bg-white text-navy"}`}>
          {item.category}
        </span>
      </div>
      <div className="p-5 flex flex-col flex-1">
        <div className="flex items-center gap-2 text-xs text-slate-400 mb-2">
          <Calendar className="h-3.5 w-3.5" /> {formatDate(item.date)}
        </div>
        <h3 className="font-bold text-navy leading-snug mb-2 line-clamp-2 group-hover:text-brandred transition-colors">
          {item.title}
        </h3>
        <p className="text-sm text-slate-500 line-clamp-2 mb-4 flex-1">{item.summary}</p>
        <span className="inline-flex items-center gap-1.5 text-sm font-bold text-brandred">
          Baca Selengkapnya <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
        </span>
      </div>
    </Link>
  );
}

export function PageHero({ eyebrow, title, description, children }) {
  return (
    <div className="bg-navy text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "radial-gradient(circle at 20% 30%, #DC2626 0, transparent 40%), radial-gradient(circle at 80% 70%, #1E3E6B 0, transparent 45%)" }} />
      <div className="container-page py-14 sm:py-16 relative">
        {eyebrow && <div className="text-xs font-bold tracking-widest uppercase text-brandred mb-3">{eyebrow}</div>}
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold">{title}</h1>
        {description && <p className="text-slate-300 mt-4 max-w-2xl text-base sm:text-lg">{description}</p>}
        {children}
      </div>
    </div>
  );
}
